<template>
  <div class="mypage-links-section">
    <h3 v-if="title" class="mypage-links-section__title">{{ title }}</h3>
    <mypage-link-list-parts :links="links" @onClickOpenModal="handleOpenModalClicked" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypageLinkListParts from '@/components/MypageTopPage/MypageTopPane/parts/MypageLinkListParts.vue'
/**
 * マイページ: トップ リンク セクション
 */
export default defineComponent({
  name: 'MypageLinksSection',
  components: {
    MypageLinkListParts,
  },
  props: {
    /**
     * セクションタイトル
     */
    title: {
      type: String,
    },
    /**
     * リンク情報リスト
     */
    links: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleOpenModalClicked(modalId: string) {
      this.$emit('openModalClicked', modalId)
    },
  },
})
</script>

<style lang="scss" scoped>
.mypage-links-section {
  width: 100%;
  margin-bottom: 24px;

  &__title {
    padding: 0 16px;
    margin-bottom: 8px;
    text-align: left;
    @include fontSetTextMedium(12);

    line-height: 1.67;
    color: $gray50;
  }
}
</style>
